import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import RecordHistoryCard from '../components/RecordHistoryCard'
import { HISTORY_FILTERS, HISTORY_FILTER_TYPES, type HistoryFilter } from '../lib/overview'

const FILTER_KEY: Record<HistoryFilter, string> = {
  all: 'CostControl_history_filter_all',
  budget: 'CostControl_history_filter_budget',
  contracts: 'CostControl_history_filter_contracts',
  changes: 'CostControl_history_filter_changes',
  applications: 'CostControl_history_filter_applications',
  invoices: 'CostControl_history_filter_invoices',
}

interface Props { projectId: string; currency: string; locale: string }

/** 1b-C spec §5: the whole project's history at the bottom of Přehled, filtered by record type. */
const ProjectHistoryCard: React.FC<Props> = ({ projectId, currency, locale }) => {
  const { t } = useTranslation()
  const [filter, setFilter] = useState<HistoryFilter>('all')
  return (
    <RecordHistoryCard
      projectId={projectId}
      currency={currency}
      locale={locale}
      entityTypes={HISTORY_FILTER_TYPES[filter]}
      headerExtra={(
        <Select value={filter} onValueChange={(v) => setFilter(v as HistoryFilter)}>
          <SelectTrigger className="h-8 w-auto min-w-[160px] text-sm"><SelectValue /></SelectTrigger>
          <SelectContent>
            {HISTORY_FILTERS.map((f) => <SelectItem key={f} value={f}>{t(FILTER_KEY[f])}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
    />
  )
}
export default ProjectHistoryCard
